import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { PaymentReceiptUseListStore } from "../../store/PaymentReceiptUseListStore";

type PaymentReceiptUseListDialogsProps = {
  store: PaymentReceiptUseListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de PaymentReceiptUse.
 * Separado para mantener PaymentReceiptUseListPage más limpio.
 */
export const PaymentReceiptUseListDialogs: React.FC<PaymentReceiptUseListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
